











import {Vue, Component} from 'vue-property-decorator';
import TrackingRoot from './tracking/root.vue';
import TrackingDomains from './tracking/tracking-domains.vue';
import DomainsApi from '@/services/rest/bemob/domains';

@Component({
  components: {
    TrackingRoot,
    TrackingDomains
  }
})
export default class Domains extends Vue {
  domainsApi: DomainsApi = new DomainsApi();

  async mounted() {
    if(!this.$store.state.cache.trackingDomains.isUploaded){
      await this.domainsApi.trackingDomainsPopulateStoreCache()
    }
  }
}
